import { Http } from './http'
import { newHttp } from './newHttp'
import { sign } from './jr-aks';
import Common from './common';
// 老网关接口，新网关接口环境在http.js中配置
let baseUrl = window.location.host=='utest.jr.jd.com' ? '//msinner.jr.jd.com/gw/generic/uc/h5/m/' : '//ms.jr.jd.com/gw/generic/uc/h5/m/'
// 新网关需要防重的接口要post请求
const SecurityApis = {
    'toDailyHome':'d81bc',
    'toDailySignIn':'78b87',
    'toGoldExchange':'1266f',
    'toWithdraw':'ff25a',
    'queryGooseTaskList':'74724',
    'receiveGooseTask':'c2f83',
    'receiveGooseTaskReward':'4fb9b',
}
let proHub = {
    // ip: "//msinner.jr.jd.com/gw/generic/uc/h5/m/", 
    //todo999 host
    ip: baseUrl,
    version: "1.0.0",
    get: function (url, reqData, callback, noIp) {
        // if (reqData && reqData.sign && !Common.initAAR2Down) {
        //     return Common.checkAAR2().then(() => {
        //         return this.getReal(url, reqData, callback, noIp)
        //     });
        // }
        return this.getReal(url, reqData, callback, noIp)
    },
    // 老的get请求先不动
    getReal: async function (url, reqData, callback, noIp) {
        if (reqData.sign) {
            // let aar = new AAR2(); // 1，new对象
            // let nonce = aar.nonce(); // 2，产生nonce
            // let signature = aar.sign(JSON.stringify(reqData.signData), nonce);
            // reqData.signature = signature
            // reqData.nonce = nonce
            // aar2 改造
            let aarData = await sign(JSON.stringify(reqData.signData))
            reqData.nonce = aarData.nonce;
            reqData.signature = aarData.signature;
        }
        // 拦截名单内的接口，访问新网关路径并加密
        let appId = SecurityApis[url]
        if (appId) {
            return Http.post(url,reqData,false,{
                security:true,appId
            }).then(res=>{
                callback(res);
            }).catch(e=>{
                callback(e);
            })
        }
        let self = this;
        // reqData.pin = Tools.getUrlString("pin") || "便宜点哦91";
        url = url + "?reqData=" + JSON.stringify(reqData);
        // console.log(self.ip + url)
        let xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if (xhr.status >= 200 && xhr.status < 400) {
                    let response = xhr.responseText;
                    // console.log(response)
                    if (response) {
                        let responseJson = JSON.parse(response);
                        if (responseJson.resultCode == 0) {//网关返回成功
                            callback(responseJson.resultData);
                        } else if (responseJson.resultCode == 3) { //未登录
                            var currentHref = window.location.href;
                            window.location.href = 'https://plogin.m.jd.com/user/login.action?appid=1&returnurl=' + encodeURIComponent(currentHref)
                        } else {
                            // console.log(responseJson.resultMsg) 
                        }
                    } else {
                        // console.log("返回数据不存在")
                        callback(false);
                    }
                } else {
                    // console.log("请求失败")
                    callback(false);
                }
            }
        };
        if (noIp) {
            xhr.open("GET", url, true);
        } else {
            xhr.open("GET", self.ip + url, true);
        }

        xhr.withCredentials = true;
        xhr.crossDomain = true;
        xhr.send();
    },
    post: function (url, reqData, callback) {
        let self = this;
        //1.拼接请求参数
        let param = "";
        for (let item in reqData) {
            param += item + "=" + reqData[item] + "&";
        }
        //2.发起请求
        let xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if (xhr.status >= 200 && xhr.status < 400) {
                    let response = xhr.responseText;
                    // console.log(response)
                    if (response) {
                        let responseJson = JSON.parse(response);
                        callback(responseJson);
                    } else {
                        // console.log("返回数据不存在")
                        callback(false);
                    }
                } else {
                    // console.log("请求失败")
                    callback(false);
                }
            }
        };
        xhr.open("POST", self.ip + url, true);
        xhr.withCredentials = true;
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.crossDomain = true;
        xhr.send('reqData={riskDeviceInfo:123456}');//reqData为字符串形式： "key=value"
    },
    newPost: async function (url, reqData, callback) {
        let aarData = await sign(JSON.stringify(reqData.signData))
            reqData.nonce = aarData.nonce;
            reqData.signature = aarData.signature;
            return newHttp.post(url,reqData,false).then(res=>{
                callback(res);
            }).catch(e=>{
                callback(false);
            })
    },
    getOtherUrl: function (url, reqData, callback) {
        let self = this;
        url = url + "?" + reqData;
        // console.log(self.ip + url)
        let xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if (xhr.status >= 200 && xhr.status < 400) {
                    let response = xhr.responseText;
                    // console.log(response)
                    if (response) {
                        let responseJson = JSON.parse(response);
                        if (responseJson.resultCode == 0) {//网关返回成功
                            callback(responseJson.resultData);
                        } else if (responseJson.resultCode == 3) { //未登录
                            // console.log("未登录");
                            window.location.href = 'https://plogin.m.jd.com/user/login.action?appid=999&returnurl=' + encodeURIComponent(window.location)
                        } else {
                            // console.log(responseJson.resultMsg)
                        }
                    } else {
                        // console.log("返回数据不存在")
                        callback(false);
                    }
                } else {
                    // console.log("请求失败")
                    callback(false);
                }
            }
        };
        xhr.open("GET", url, true);
        xhr.withCredentials = true;
        xhr.send();
    }
};
export default proHub;   
